import {
  Box,
  Tooltip,
  Typography,
  Grid,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import { Screen } from "../../../main/components/screen/Screen";
import { Accordion } from "../../../main/components/accordion/Accordion";
import CardBox from "../../../main/components/CardBox";
import { TypeInfo } from "../../../main/components/TypeInfo/TypeInfo";
import WarningIcon from "@mui/icons-material/Warning";
import CheckIcon from "@mui/icons-material/Check";
import { getSeverityByType } from "./AlarmsDetails";
import { formatDateAndHour } from "../../../main/utils/utils";
import { useContext, useEffect, useState } from "react";
import { alarmsApi } from "../../../services/api";
import { AlarmEvent, CurrentAlarms } from "../types";
import Loading from "../../../main/components/Loading";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import BaseButton from "../../../main/components/BaseButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useNavigate } from "react-router-dom";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import { MainContext } from "../../../main/context/MainContextProvider";
import FilterListIcon from "@mui/icons-material/FilterList";
import AlarmAccordion from "../components/AlarmAccordion";
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

export default function AlarmsList() {
  const navigate = useNavigate();

  const { selectedDashboardUsina: selectedUsina, setSelectedDashboardUsina: setSelectedUsina, clientUsinas, toastNotifications, setToastNotifications } = useContext(MainContext);

  const path = window.location.pathname;

  const alarmUsinaIdFromPath = path.split("/")[3];
  const alarmCodeFromPath = path.split("/")[4];
  const alarmNameFromPath = path.split("/")[2];

  const [clientHasUsinaFromPath, setClientHasUsinaFromPatch] = useState<boolean>(false)

  useEffect(() => {
    if (alarmUsinaIdFromPath) {
      var currentUsina = clientUsinas?.find((usina) => usina.usinaIds.ropInputId === Number(alarmUsinaIdFromPath));
      if (currentUsina) {
        alarmUsinaIdFromPath && setSelectedUsina(clientUsinas?.find((usina) => usina.usinaIds.ropInputId === Number(alarmUsinaIdFromPath)))
        setClientHasUsinaFromPatch(true)
      }
      else {
        setClientHasUsinaFromPatch(false)

        const newNotifications = {
          isAdding: true,
          notifications: [
            ...toastNotifications.notifications,
            {
              severity: "error" as const,
              text: `O cliente selecioado não tem acesso a usina ${alarmNameFromPath}, A lista responderá à usina ${selectedUsina?.name ?? ""}`,
            },
          ],
        };
        setToastNotifications(newNotifications);
      }
    }
  }, [alarmUsinaIdFromPath])

  const [loading, setLoading] = useState(false);
  const [alarmList, setAlarmList] = useState<CurrentAlarms>();
  const [lastUpdateAt, setLastUpdateAt] = useState<Date>();
  const tooltipMesssage = lastUpdateAt
    ? `Última atualização em ${formatDateAndHour(lastUpdateAt)}`
    : undefined;
  const [alarmsOpened, setAlarmsOpened] = useState<string[]>([""]);
  const [selectedStatus, setSelectedStatus] = useState<boolean>();
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);

  const [allUGs, setAllUgs] = useState<string[]>([]);
  const [AllINVs, setAllINVs] = useState<string[]>([]);
  const [selectedUG, setSelectedUG] = useState<string[]>([]);
  const [selectedINV, setSelectedINV] = useState<string[]>([]);

  const [isFilterVisible, setFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setFilterVisible(!isFilterVisible);
  };

  const toggleString = (area: string) => {
    if (alarmsOpened.includes(area)) {
      const newArray = alarmsOpened.filter((item) => item !== area);
      setAlarmsOpened(newArray);
    } else {
      setAlarmsOpened([...alarmsOpened, area]);
    }
  };

  function StringVerificator(string: string): boolean {
    const hasString = alarmsOpened.find((item) => item === string);
    return hasString !== undefined;
  }

  const handleCheckboxToggle = (
    areaPart: string,
    areaType: "UG" | "INV"
  ) => {
    if (areaType === "UG") {
      const ugIsSelected = !!selectedUG.find((ug) => ug == areaPart);

      if (ugIsSelected) {
        setSelectedUG(selectedUG.filter((ug) => ug != areaPart))
      } else {
        setSelectedUG([...selectedUG, areaPart])
      }
    } else {
      const invIsSelected = !!selectedINV.find((inv) => inv == areaPart);

      if (invIsSelected) {
        setSelectedINV(selectedINV.filter((inv) => inv != areaPart))
      } else {
        setSelectedINV([...selectedINV, areaPart])
      }
    }
  };

  async function updateList() {
    setLoading(true);
    setSelectedLetter(null);
    try {
      if (selectedUsina) {
        const allAlarms = await alarmsApi.getAlarms();
        const currentAlarmListResponse = await alarmsApi.getCurrentAlarms(
          String(selectedUsina?.usinaIds.ropInputId)
        );

        const alarmList: CurrentAlarms = {
          ugCurrentAreas: currentAlarmListResponse.ugCurrentAreas.map((ugArea) => {
            ugArea.areasAlarms.forEach((areaTypeAlarm) => {
              areaTypeAlarm.alarmAreas.forEach((areaAlarm) => {
                areaAlarm.alarmEvents = areaAlarm.alarmEvents.map((alarmEvent) => {
                  const currentAlarm = allAlarms.data.find((alarm) => alarm.code === alarmEvent.code);

                  alarmEvent.severity = currentAlarm ? currentAlarm.severity : alarmEvent.severity;

                  return alarmEvent;
                });
              });
            });

            return ugArea;
          })
        };

        setAlarmList(alarmList);
        setLastUpdateAt(new Date());
      }
    } catch (error) {
      throw new Error("Erro ao carregar lista de alarmes");
    } finally {
      setLoading(false);
    }
  }


  const filteredAlarmList = getFilteredAlarmEvents(
    alarmList,
    selectedStatus,
    selectedLetter,
    selectedUG,
    selectedINV,
    clientHasUsinaFromPath,
    alarmCodeFromPath
  );

  const severityTextSize = { fontSize: { xs: "13px", sx: "15px" } };

  useEffect(() => {
    updateList();
  }, [selectedUsina]);

  useEffect(() => {
    setSelectedINV([])
  }, [selectedLetter])

  useEffect(() => {
    setAllUgs(alarmList?.ugCurrentAreas.map((ugCurrent) => ugCurrent.ug == "" ? "GERAL" : ugCurrent.ug) ?? [])
    setAllINVs(alarmList?.ugCurrentAreas.flatMap((ugCurrent) => {
      let allFiltedAreas: string[] = [];
      ugCurrent.areasAlarms.forEach((areaTypeAlarm) => {
        if (areaTypeAlarm.areaType === "INV") {
          areaTypeAlarm.alarmAreas.forEach((alarmArea) => {
            if (!allFiltedAreas.includes(alarmArea.area)) {
              allFiltedAreas.push(alarmArea.area);
            }
          });
        }
      })
      return allFiltedAreas.reduce((accumulator, current) => {
        if (!accumulator.includes(current)) {
          accumulator.push(current);
        }
        return accumulator;
      }, [] as string[]);
    }) ?? [])
  }, [alarmList])

  const alarmOnClick = (alarmEvent: AlarmEvent) => {
    const stringAlarm = alarmEvent.message.split(":")[0]
    navigate(
      `/alarm/details`, {
      state: {
        usinaName: alarmEvent?.usinaName ?? "",
        usinaId: alarmEvent?.usinaId ?? "",
        ug: alarmEvent.ug ?? "",
        area: alarmEvent.area ?? "",
        code: alarmEvent.code ?? "",
        string: stringAlarm && stringAlarm.includes("String") ? stringAlarm : "",
        message: alarmEvent.message ?? ""
      }
    }
    )
    return
  }

  const renderChipValue = (selected: string[]) => {
    const visibleChips = selected.slice(0, 2);
    const remainingChips = selected.length - visibleChips.length;
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {visibleChips.map((value) => (
          <Chip key={value} size="small" label={value} />
        ))}
        {remainingChips > 0 && (
          <Chip key="more" size="small" label={`+${remainingChips}`} />
        )}
      </Box>
    );
  };

  return (
    <Screen.Root>
      {loading ? (
        <>
          <Screen.Container>
            <Loading />
          </Screen.Container>
        </>
      ) : (
        <>
          <Screen.Header>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "400",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
            >
              Alarmes por equipamento
            </Typography>
          </Screen.Header>
          <Screen.Container>
            {alarmList && alarmList.ugCurrentAreas.length > 0 ? (
              <>
                <Box
                  sx={{
                    columnGap: 1,
                    rowGap: 2,
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { xs: "center", md: "flex-end" },
                    alignItems: "center",
                    marginTop: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <Tooltip title={tooltipMesssage} placement="bottom">
                    <Box>
                      <BaseButton
                        onClick={updateList}
                        sx={{ height: "35px" }}
                        title="Atualizar"
                        startIcon={<RestartAltIcon />}
                      />
                    </Box>
                  </Tooltip>
                  <Box>
                    <BaseButton
                      onClick={() => {
                        setSelectedStatus(undefined);
                        setSelectedLetter(null);
                        setSelectedUG([])
                        setSelectedINV([])
                      }}
                      sx={{ height: "35px" }}
                      title="Limpar filtros"
                      startIcon={<FilterListOffIcon />}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      columnGap: 1,
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <PrimaryBaseButton
                      isActive={selectedStatus === undefined}
                      onClick={() => {
                        setSelectedStatus(undefined);
                      }}
                      sx={{ height: "35px" }}
                      title="Todos"
                    />
                    <PrimaryBaseButton
                      isActive={selectedStatus === true}
                      onClick={() => {
                        setSelectedStatus(true);
                      }}
                      sx={{ height: "35px" }}
                      title="Ativos"
                    />
                    <PrimaryBaseButton
                      isActive={selectedStatus === false}
                      onClick={() => {
                        setSelectedStatus(false);
                      }}
                      sx={{ height: "35px" }}
                      title="Inativos"
                    />
                    <FilterListIcon
                      onClick={toggleFilterVisibility}
                      sx={{
                        cursor: "pointer",
                        color: isFilterVisible ? "#FF9F0C" : "inherit",
                      }}
                    />
                  </Box>

                </Box>
                {isFilterVisible && (
                  <Grid
                    container
                    spacing={0}
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                      flexWrap: "wrap",
                      marginTop: { xs: "5px", md: "10px" },
                      marginBottom: { xs: "16px", md: "0px" },
                    }}
                  >

                    <Box

                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: 0,
                        marginY: { xs: "10px" },
                        width: { xs: "100%", md: "auto" },
                        justifyContent: "center"
                      }}
                    >
                      {["UG", "INV"].map((letter) => (
                        <Tooltip title={letter == "INV" && selectedLetter != "INV" ? "Selecione o filtro por INV para liberar!" : ""}>
                          <FormControl
                            sx={{
                              marginRight: letter == "UG" ? "10px" : "0px",
                              minWidth: "150px",
                            }}
                            disabled={letter == "INV" && selectedLetter != "INV"}
                          >
                            <InputLabel
                              id="demo-multiple-chip-label"
                              sx={{
                                top: (letter == "UG" && selectedUG.length > 0) || (letter == "INV" && selectedINV.length > 0) ? 0 : "50%",
                                transform: "translateY(-50%)",
                                left: 10,
                                '&.Mui-focused': {
                                  top: 0,
                                  transform: "translateY(-50%)",
                                  left: 10
                                }
                              }}
                            >
                              {letter}
                            </InputLabel>
                            <Select

                              labelId="demo-multiple-chip-label"
                              id="demo-multiple-chip"
                              multiple
                              value={letter === "UG" ? selectedUG : selectedINV}
                              renderValue={renderChipValue}
                              sx={{
                                fontSize: "16px",
                                width: "100%",
                                height: "35px",
                                marginRight: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Box
                                sx={{
                                  maxHeight: "200px",
                                  // marginLeft: "-10px",
                                }}
                              >
                                {letter === "UG" ? allUGs.map((ug) =>
                                  <MenuItem
                                    onClick={
                                      () =>
                                        handleCheckboxToggle(
                                          ug,
                                          letter as "UG" | "INV"
                                        )
                                    }
                                    value={ug}>

                                    <Checkbox
                                      checked={
                                        letter === "UG"
                                          ? selectedUG.includes(ug)
                                          : selectedINV.includes(ug)
                                      }
                                      onChange={
                                        () =>
                                          handleCheckboxToggle(
                                            ug,
                                            letter as "UG" | "INV"
                                          )
                                      }
                                    />
                                    {ug}
                                  </MenuItem>
                                )
                                  : AllINVs.map((inv) =>
                                    <MenuItem
                                      onClick={
                                        () =>
                                          handleCheckboxToggle(
                                            inv,
                                            letter as "UG" | "INV"
                                          )
                                      }
                                      value={inv}>
                                      <Checkbox
                                        checked={
                                          letter === "UG"
                                            ? selectedUG.includes(inv)
                                            : selectedINV.includes(inv)
                                        }
                                        onChange={
                                          () =>
                                            handleCheckboxToggle(
                                              inv,
                                              letter as "UG" | "INV"
                                            )
                                        }
                                      />
                                      {inv}
                                    </MenuItem>
                                  )}
                              </Box>
                            </Select>
                          </FormControl>
                        </Tooltip>
                      ))}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        columnGap: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        rowGap: "8px",
                        marginTop: { xs: "6px", md: "0px" },
                        width: { xs: "100%", md: "auto" },
                        marginLeft: { xs: "0px", md: "10px" }
                      }}
                    >
                      {["TRK", "INV", "TRF", "SUB", "COM"].map((letter, i) => (
                        <PrimaryBaseButton
                          key={i}
                          isActive={letter === selectedLetter}
                          onClick={() => setSelectedLetter(letter)}
                          sx={{ height: "35px" }}
                          title={letter}
                        />
                      ))}
                    </Box>
                  </Grid>
                )}
                <Box sx={{ width: "100%", marginTop: "8px" }}>
                  {filteredAlarmList?.ugCurrentAreas.map((ugCurrentArea) => {
                    const getUgName = (ugName: string) => {
                      if (ugName == "" || ugName == null || ugName == undefined) return "GERAL"
                      return ugName
                    }
                    return ugCurrentArea.areasAlarms.length > 0 && (<AlarmAccordion
                      toggleDetails={() => {
                        toggleString(`${ugCurrentArea.ug ?? "GERAL"} - UG`);
                      }}
                      showDetails={StringVerificator(`${ugCurrentArea.ug ?? "GERAL"} - UG`)}
                      title={getUgName(ugCurrentArea.ug)}
                    >
                      {
                        ugCurrentArea.areasAlarms.map((areaAlarms) => (
                          <CardBox sx={{ marginBottom: "8px", paddingTop: "14px" }}>
                            <AlarmAccordion
                              toggleDetails={() => {
                                toggleString(`${areaAlarms.areaType} - ${ugCurrentArea.ug}`);
                              }}
                              showDetails={StringVerificator(`${areaAlarms.areaType} - ${ugCurrentArea.ug}`)}
                              title={areaAlarms.areaType}
                              removeBorderBottom
                            >
                              {areaAlarms.alarmAreas?.map((equipment, i) => (
                                <Accordion.Root key={i} sx={{ marginTop: "15px", marginBottom: "0px" }}>
                                  <Accordion.Header
                                    toggleDetails={() => {
                                      toggleString(`${equipment.area} - ${areaAlarms.areaType} - ${ugCurrentArea.ug}`);
                                    }}
                                    showDetails={StringVerificator(`${equipment.area} - ${areaAlarms.areaType} - ${ugCurrentArea.ug}`)}
                                    title={`${equipment.area}`}
                                    typographySx={{
                                      fontSize: { xs: "13px", sm: "16px" },
                                      width: "50%",
                                      textAlign: "left",
                                    }}
                                    children={
                                      <Typography
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          paddingLeft: "16px",
                                          fontSize: "11px",
                                          color: "#FF9F0C",
                                        }}
                                      >
                                        {equipment.alarmEvents.length}{" "}
                                        {equipment.alarmEvents.length > 1
                                          ? "Alarmes"
                                          : "Alarme"}
                                      </Typography>
                                    }
                                  />
                                  <Accordion.Content
                                    showDetails={StringVerificator(`${equipment.area} - ${areaAlarms.areaType} - ${ugCurrentArea.ug}`)}
                                    sx={{ maxHeight: "400px", overflow: "auto" }}
                                  >
                                    {equipment.alarmEvents?.map((alarmEvent, i) => (
                                      <Box
                                        onClick={() => alarmOnClick(alarmEvent)}
                                        sx={{
                                          marginY: "8px",
                                          borderBottom: "1px",
                                          borderBottomColor: "#9DA8B4",
                                          borderBottomStyle: "solid",
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                          paddingBottom: "6px",
                                          minHeight: "46px"
                                        }}
                                        key={i}
                                      >
                                        <Box
                                          sx={{
                                            width: { xs: "31%", sm: "20%" },
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: { xs: "10px", md: "13px" },
                                            }}
                                          >
                                            {alarmEvent.message}
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            width: "20%",
                                            display: { xs: "none", sm: "flex" },
                                            justifyContent: "center"
                                          }}
                                        >
                                          <Typography
                                            sx={{ fontSize: { sm: "10px", md: "13px" } }}
                                          >
                                            Código -{" "}
                                            {alarmEvent.code == ""
                                              ? "Não informado"
                                              : alarmEvent.code}
                                          </Typography>
                                        </Box>
                                        <TypeInfo.Root
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: { xs: "38%", sm: "20%" },
                                          }}
                                          backgroundColor={"transparent"}
                                        >
                                          {alarmEvent.active !== null && (
                                            <TypeInfo.Icon
                                              icon={
                                                alarmEvent.active ? (
                                                  <WarningIcon
                                                    sx={{
                                                      fontSize: { xs: "13px", md: "18px" },
                                                      color: "#FF0000",
                                                    }}
                                                  />
                                                ) : (
                                                  <CheckIcon
                                                    sx={{
                                                      fontSize: { xs: "13px", md: "18px" },
                                                      color: "#27AE60",
                                                    }}
                                                  />
                                                )
                                              }
                                            />
                                          )}
                                          <TypeInfo.Text
                                            sx={{
                                              fontSize: { xs: "10px", md: "13px" },
                                              color:
                                                alarmEvent.active === null
                                                  ? "#FFFFFF"
                                                  : alarmEvent.active
                                                    ? "#FF0000"
                                                    : "#27AE60",
                                            }}
                                            text={
                                              alarmEvent.active === null
                                                ? "Status não informado"
                                                : alarmEvent.active
                                                  ? "Alarme Ativo"
                                                  : "Alarme Inativo"
                                            }
                                          />
                                        </TypeInfo.Root>
                                        <Box
                                          sx={{
                                            width: { xs: "31%", sm: "20%" },
                                          }}
                                        >
                                          {getSeverityByType(
                                            alarmEvent.severity,
                                            severityTextSize
                                          )}
                                        </Box>
                                        <Typography
                                          sx={{
                                            width: "15%",
                                            display: { xs: "none", sm: "flex" },
                                            justifyContent: "center"
                                          }}
                                          fontSize={"13px"}
                                        >
                                          {formatDateAndHour(alarmEvent.createdAt)}
                                        </Typography>
                                        <Box
                                          sx={{
                                            width: "5%",
                                            display: { xs: "none", sm: "flex" },
                                            justifyContent: "center"
                                          }}
                                          onClick={(e) => {
                                            alarmEvent.idSS && e.stopPropagation();
                                            navigate(
                                              alarmEvent.idSS
                                                ? `/service-request/${alarmEvent.idSS}`
                                                : ""
                                            );
                                          }}
                                        >
                                          <Tooltip
                                            title={
                                              alarmEvent.idSS
                                                ? "Este alarme possui SS"
                                                : "Este alarme não possui SS"
                                            }
                                          >
                                            <ElectricalServicesIcon
                                              sx={{
                                                color: alarmEvent.idSS
                                                  ? "#FF9F0C"
                                                  : "#a8b6bc",
                                              }}
                                            />
                                          </Tooltip>
                                        </Box>
                                      </Box>
                                    ))}
                                  </Accordion.Content>
                                </Accordion.Root>
                              ))}
                            </AlarmAccordion>
                          </CardBox>
                        ))
                      }
                    </AlarmAccordion>)
                  }
                  )}

                </Box>
              </>
            ) : (
              <Screen.Container>
                <EmptyStateNotFound title="Nenhum registro encontrado" />
              </Screen.Container>
            )}
          </Screen.Container>
        </>
      )}
    </Screen.Root>
  );
}

function getFilteredAlarmEvents(
  alarmList: CurrentAlarms | undefined,
  selectedStatus: boolean | undefined,
  selectedLetter: string | null,
  selectedUG: string[],
  selectedINV: string[],
  clientHasUsinaFromPath: boolean,
  alarmCodeFromPath?: string,
): CurrentAlarms | undefined {
  if (alarmList === undefined) {
    return undefined;
  }

  const hasSelectedUg = selectedUG.length > 0
  const hasSelectedINV = selectedINV.length > 0

  let filteredAlarmListBySelectedUg: CurrentAlarms = alarmList

  if (hasSelectedUg) {
    filteredAlarmListBySelectedUg = { ugCurrentAreas: filteredAlarmListBySelectedUg?.ugCurrentAreas.filter((ugCurrent) => selectedUG.find((ug) => ug == (ugCurrent.ug != "" ? ugCurrent.ug : "Geral"))) }
  }

  let filteredAlarmListBySelectedInv: CurrentAlarms = filteredAlarmListBySelectedUg

  if (hasSelectedINV && selectedLetter == "INV") {
    filteredAlarmListBySelectedInv = {
      ugCurrentAreas: filteredAlarmListBySelectedUg?.ugCurrentAreas.filter((ugCurrent) => {
        const filteredAreaTypeAlarms = ugCurrent.areasAlarms.filter((areaTypeAlarm) => {
          const filteredAlarmAreas = areaTypeAlarm.alarmAreas.filter((alarmArea) => {
            return selectedINV.includes(alarmArea.area);
          });
          return filteredAlarmAreas.length > 0;
        });
        return filteredAreaTypeAlarms.length > 0;
      }).map((ugCurrent) => {
        return {
          ...ugCurrent,
          areasAlarms: ugCurrent.areasAlarms.map((areaTypeAlarm) => {
            const filteredAlarmAreas = areaTypeAlarm.alarmAreas.filter((alarmArea) => {
              return selectedINV.includes(alarmArea.area);
            });
            return {
              ...areaTypeAlarm,
              alarmAreas: filteredAlarmAreas,
            };
          }).filter((areaTypeAlarm) => areaTypeAlarm.alarmAreas.length > 0),
        };
      })

    }
  }

  let filteredAlarmListByStatus: CurrentAlarms = filteredAlarmListBySelectedInv

  if (selectedStatus != null) {
    filteredAlarmListByStatus = {
      ugCurrentAreas: filteredAlarmListBySelectedInv?.ugCurrentAreas.filter((ugCurrent) => {
        const filteredAreaTypeAlarms = ugCurrent.areasAlarms.filter((areaTypeAlarm) => {
          const filteredAlarmAreas = areaTypeAlarm.alarmAreas.filter((alarmArea) => {
            const filteredAlarmEvents = alarmArea.alarmEvents.filter((alarmEvent) => {
              return alarmEvent.active === selectedStatus;
            });
            return filteredAlarmEvents.length > 0;
          });
          return filteredAlarmAreas.length > 0;
        });
        return filteredAreaTypeAlarms.length > 0;
      }).map((ugCurrent) => {
        return {
          ...ugCurrent,
          areasAlarms: ugCurrent.areasAlarms.map((areaTypeAlarm) => {
            const filteredAlarmAreas = areaTypeAlarm.alarmAreas.map((alarmArea) => {
              const filteredAlarmEvents = alarmArea.alarmEvents.filter((alarmEvent) => {
                return alarmEvent.active === selectedStatus;
              });
              return {
                ...alarmArea,
                alarmEvents: filteredAlarmEvents,
              };
            }).filter((alarmArea) => alarmArea.alarmEvents.length > 0)
            return {
              ...areaTypeAlarm,
              alarmAreas: filteredAlarmAreas,
            };
          }).filter((areaTypeAlarm) => areaTypeAlarm.alarmAreas.length > 0),
        };
      })
    }
  }

  let filteredAlarmListByLetter: CurrentAlarms = filteredAlarmListByStatus

  if (selectedLetter) {
    filteredAlarmListByLetter = {
      ugCurrentAreas: filteredAlarmListByStatus?.ugCurrentAreas.filter((ugCurrent) => {
        const filteredAreaTypeAlarms = ugCurrent.areasAlarms.filter((areaTypeAlarm) => areaTypeAlarm.areaType === selectedLetter);

        return filteredAreaTypeAlarms.length > 0;
      }).map((ugCurrent) => {
        return {
          ...ugCurrent,
          areasAlarms: ugCurrent.areasAlarms.filter((areaTypeAlarm) => areaTypeAlarm.areaType === selectedLetter),
        };
      })
    }
  }

  let filteredAlarmListByPath: CurrentAlarms = filteredAlarmListByLetter

  if (alarmCodeFromPath != undefined && clientHasUsinaFromPath) {

    filteredAlarmListByPath = {
      ugCurrentAreas: filteredAlarmListByLetter?.ugCurrentAreas.filter((ugCurrent) => {
        const filteredAreaTypeAlarms = ugCurrent.areasAlarms.filter((areaTypeAlarm) => {
          const filteredAlarmAreas = areaTypeAlarm.alarmAreas.filter((alarmArea) => {
            const filteredAlarmEvents = alarmArea.alarmEvents.filter((alarmEvent) => {
              return selectedStatus ? alarmEvent.active === selectedStatus : alarmEvent;
            });
            return filteredAlarmEvents.length > 0;
          });
          return filteredAlarmAreas.length > 0;
        });
        return filteredAreaTypeAlarms.length > 0;
      }).map((ugCurrent) => {
        return {
          ...ugCurrent,
          areasAlarms: ugCurrent.areasAlarms.map((areaTypeAlarm) => {
            const filteredAlarmAreas = areaTypeAlarm.alarmAreas.map((alarmArea) => {
              const filteredAlarmEvents = alarmArea.alarmEvents.filter((alarmEvent) => {
                return (alarmEvent.code === alarmCodeFromPath)
              });
              return {
                ...alarmArea,
                alarmEvents: filteredAlarmEvents,
              };
            }).filter((alarmArea) => alarmArea.alarmEvents.length > 0)
            return {
              ...areaTypeAlarm,
              alarmAreas: filteredAlarmAreas,
            };
          }).filter((areaTypeAlarm) => areaTypeAlarm.alarmAreas.length > 0),
        };
      })
    }
  }

  return filteredAlarmListByPath
}
